<div class="row">
    <div [class.d-none]="countDown>0" class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div *ngIf="!isDone">
            <div class="d-flex justify-content-center mb-3">
                <div class="quiz-counter">
                    {{numberOfQuiz}} of {{totalQuiz}}
                </div>
            </div>
            <div class="progress mb-3">
                <div class="progress-bar" role="progressbar" [style.width]="percentQuiz+'%'"></div>
            </div>
            <div class="card bg-light text-dark rounded-5 mb-3 position-relative">
                <div style="margin-top:-1px;" class="px-4 w-100 position-absolute start-0">
                    <div class="bg-success progress-timeout rounded" style="height:3px;" [style.width]="percentTimeOut+'%'">&nbsp;</div>
                </div>
                <div class="card-body text-center">
                    <div *ngIf="currentAnswer.length" class="question d-flex justify-content-center align-items-center">
                        <img style="max-height:100px;width:auto;" src="{{assetUrl}}{{currentQuestion.image}}">
                    </div>
                </div>
            </div>
            <div *ngIf="currentAnswer.length" class="row d-flex flex-wrap justify-content-between">
                <div *ngFor="let a of currentAnswer" class="col-6 answer col-sm-6 col-md-6 col-lg-6 col-xl-6 text-center mb-3">
                    <button class="btn btn-ls w-100 rounded-4 text-center h-100" (click)="answerQuiz(a)">
                        <img style="max-height:100px;width:auto;" src="{{assetUrl}}{{a.image}}">
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="isDone" class="px-md-5">
            <app-finish [point]="point" [time]="(elapsedTime/1000)" [title]="'Post-Switch'"></app-finish>
        </div>
    </div>
    <div *ngIf="countDown>0 && !loading.status" class="col-12 text-center p-5">
        <h4>Ready?</h4>
        <h3>{{countDown}}</h3>
    </div>
</div>
